var _defs, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinkflower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    "data-name": "Layer 5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 121 124.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6008c;}.cls-2{fill:#edeb73;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.58,508.6l-12.79-2.54-9.35,9.1c-14.68,14.29-39.37,5.54-41.78-14.8l-1.54-13-11.54-6.08c-18.12-9.54-17.43-35.72,1.17-44.3l11.84-5.47,2.22-12.85c3.48-20.19,28.59-27.62,42.5-12.59l8.85,9.58,12.92-1.86c20.27-2.93,35.1,18.65,25.1,36.53l-6.38,11.38,5.77,11.71C196.62,491.82,180.67,512.6,160.58,508.6Z",
    transform: "translate(-70.38 -398.16)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.62,
    cy: 63.34,
    r: 22
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinkflower);
export default __webpack_public_path__ + "static/media/pink flower.3ef68b4c.svg";
export { ForwardRef as ReactComponent };